import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace, isDef, throttle} from '../../common/utils';
import {getElementTop, getScroller, getScrollTop} from '../../common/utils/dom';
import {BindEventMixin} from '../../common/mixins/event';

var _createNamespace = createNamespace('sticky'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

export default {
    mixins: [
        BindEventMixin(function(bind, isBind) {
            if (!this.scroller) {
                this.scroller = getScroller(this.$el);
            }

            if (this.observer) {
                var method = isBind ? 'observe' : 'unobserve';
                this.observer[method](this.$el);
            }

            bind(this.scroller, 'scroll', this.onScroll, true);
            this.onScroll();
        })
    ],
    name: getComponentName('Sticky'),
    data: function data() {
        return {
            fixed: false,
            height: 0,
            transform: 0,
            fixPositionLeft: 0
        };
    },
    watch: {
        fixed: function fixed(after) {
            if (after) {
                this.$emit('fixed');
            } else {
                this.$emit('unfixed');
            }
        }
    },
    props: {
        zIndex: [Number, String],
        container: null,
        offsetTop: {
            type: [Number, String],
            default: 0
        }
    },
    created: function created() {
        this.onScroll = throttle(this.onScrollhander, 16);
    },
    mounted: function mounted() {
        var _this = this;

        if (!this.scroller) {
            this.scroller = getScroller(this.$el);
        }

        if (this.scroller instanceof Element) {
            var style = window.getComputedStyle(this.scroller);

            if (style.transform !== 'none' || style.perspective !== 'none' || style.willChange !== 'auto') {
                console.error('滚动的元素 css 属性值对 fixed 定位有影响');
            }
        }

        this.$on('unfixed', function() {
            _this.fixPositionLeft = 0;
        });
        this.$on('fixed', function() {
            var rect = _this.$el.getBoundingClientRect();

            _this.fixPositionLeft = rect.left;
        });
    },
    computed: {
        style: function style() {
            if (!this.fixed) {
                return;
            }

            var style = {};

            if (isDef(this.zIndex)) {
                style['zIndex'] = this.zIndex;
            }

            if (this.offsetTop && this.fixed) {
                style['top'] = ''.concat(this.offsetTop, 'px');
            }

            if (this.fixed && this.fixPositionleft > 0) {
                style['left'] = ''.concat(this.fixPositionleft, 'px');
            }

            if (this.fixed && this.fixPositionWidth > 0) {
                style['width'] = ''.concat(this.fixPositionWidth, 'px');
            }

            if (this.transform) {
                style['transform'] = 'translate3d(0, '.concat(this.transform, 'px, 0)');
            }

            return style;
        }
    },
    methods: {
        onScrollhander: function onScrollhander() {
            var _this2 = this;

            this.height = this.$el.offsetHeight;
            var container = this.container;
            var offsetTop = +this.offsetTop;
            var scrollTop = getScrollTop(this.scroller);
            var topToPageTop = getElementTop(this.$el, this.scroller);

            var emitScrollEvent = function emitScrollEvent(scrollTop, isFixed) {
                _this2.$emit('scroll', {
                    scrollTop: scrollTop,
                    isFixed: isFixed
                });
            };

            if (container) {
                container = typeof container === 'string' ? document.querySelector(container) : container;

                if (!container) {
                    throw new Error('container is not existed: '.concat(container));
                }

                var bottomToPageTop = topToPageTop + container.offsetHeight;

                if (scrollTop + offsetTop + this.height > bottomToPageTop) {
                    var distanceToBottom = this.height + scrollTop - bottomToPageTop;

                    if (distanceToBottom < this.height) {
                        this.fixed = true;
                        this.transform = -(distanceToBottom + offsetTop);
                    } else {
                        this.fixed = false;
                    }

                    emitScrollEvent(scrollTop, this.fixed);
                    return;
                }
            }

            if (scrollTop + offsetTop > topToPageTop) {
                this.fixed = true;
                this.transform = 0;
            } else {
                this.fixed = false;
            }

            emitScrollEvent(scrollTop, this.fixed);
        }
    },
    render: function render() {
        var h = arguments[0];
        var fixed = this.fixed;
        var style = {
            height: fixed ? ''.concat(this.height, 'px') : null
        };
        return h(
            'div',
            {
                style: style
            },
            [
                h(
                    'div',
                    {
                        class: b({
                            fixed: fixed
                        }),
                        style: this.style
                    },
                    [this.$slots.default]
                )
            ]
        );
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    },
    destroyed: function destroyed() {
        this.scroller.removeEventListener('scroll', this.onScroll);
    }
};
